<app-page-header [data]="header()" [fullPath]="fullPath()" />
@if (headline()) {
<app-base-text [text]="headline()" [big]="true" [bold]="true" [gotham]="true" [htmlTag]="'h1'"
    class="content-blog-overview__intro module" />
}
<div class="content-blog-overview__blogs">
@for (blogPage of blogPages(); track $index) {
    <app-blog-teaser [data]="blogPage"/>
}
</div>
@for(element of contentElements(); track $index) {
<ng-container *ngComponentOutlet="element?.component; inputs: element?.inputs" />
}
<app-page-footer [data]="footer()" />